import * as React from "react";
import { Button } from "@material-ui/core";
import { Check, InfoOutlined } from "@material-ui/icons";
import HtmlTooltip from "common/components/HtmlTooltip/HtmlTooltip";
import { useEventManagerStyles } from "./eventManagerStyles";
import { utc } from "./utcDate";

const RESULT_LABELS = { sent: "Sent", skipped: "Skipped" };

const ROW_INFO = {
	picksOpen:
		"Goes to everyone subscribed for this game the moment the stage opens, whether or not they play this event. Auto-send needs AUTOMATIC_NOTIFICATIONS_ENABLED.",
	reminder:
		"Goes an hour before picks close, only to users who picked an earlier stage of this event and are missing this one, never the whole game. Skips the first stage and needs PICK_REMINDER_ENABLED.",
	results:
		"Fires when trophies are delivered, not on a schedule, and only to users who picked in this event and opted in to results. Needs RESULTS_NOTIFICATION_ENABLED.",
};

const pushTitle = (p) => {
	if (p.status === "sent") {
		return `Sent ${utc(p.sentAt)} UTC, delivered to ${p.deliveredCount}`;
	}
	return p.status === "skipped" ? "Skipped, no push went out" : "Not sent yet";
};

export default function NotificationsTab({ event, canSend, onSendPush }) {
	const classes = useEventManagerStyles();
	const stages = event.stages ?? [];
	const results = event.resultsPush ?? {};

	const pillClass = (p) => {
		if (p.status === "sent") {
			return `${classes.pill} ${classes.pillText} ${classes.pillSent}`;
		}
		if (p.status === "skipped") {
			return `${classes.pill} ${classes.pillText} ${classes.pillDim}`;
		}
		return `${classes.pill} ${classes.pillText} ${classes.pillPending}`;
	};

	const infoLabel = (text, info) => (
		<span className={`${classes.rowLabel} ${classes.labelInfo}`}>
			{text}
			<HtmlTooltip title={info}>
				<InfoOutlined className={classes.infoIcon} />
			</HtmlTooltip>
		</span>
	);

	const stagePill = (stage, push) => (
		<span
			key={stage.stageIndex}
			className={pillClass(push)}
			title={pushTitle(push)}
		>
			{push.status === "sent" ? <Check fontSize="inherit" /> : null}
			{stage.name}
		</span>
	);

	return (
		<div className={classes.rowGrid}>
			{stages.length ? (
				<>
					{infoLabel("Picks open", ROW_INFO.picksOpen)}
					<div className={classes.pills}>
						{stages.map((s) => stagePill(s, s.picksOpenPush))}
						{canSend ? (
							<Button variant="contained" color="primary" onClick={onSendPush}>
								Send push
							</Button>
						) : null}
					</div>
					{infoLabel("Reminder", ROW_INFO.reminder)}
					<div className={classes.pills}>
						{stages.map((s) => stagePill(s, s.reminderPush))}
					</div>
				</>
			) : null}
			{infoLabel("Results", ROW_INFO.results)}
			<div className={classes.pills}>
				<span className={pillClass(results)} title={pushTitle(results)}>
					{results.status === "sent" ? <Check fontSize="inherit" /> : null}
					{RESULT_LABELS[results.status] ?? "Not sent"}
				</span>
			</div>
		</div>
	);
}
